import { useQuery } from '@tanstack/react-query';
import { queryFn } from './queryFn';
import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

type Args = {
  portfolioId: Portfolio['id'];
  startTimestamp: number;
  endTimestamp: number;
};

const QUERY_KEY = 'DEMO_PORTFOLIO_PERFORMANCE_TIMESERIES' as const;

export const useDemoPortfolioPerformanceTimeseries = ({
  portfolioId,
  startTimestamp,
  endTimestamp,
}: Args) => {
  const { data, status } = useQuery({
    queryKey: [QUERY_KEY, portfolioId, { startTimestamp, endTimestamp }],
    queryFn,
    retry: 1,
  });

  return {
    data,
    status,
  };
};
